<template>
	<center v-if="vdat">
		<div class="vocab-container">
			<h1>{{ title }}</h1>
			<div class="vocab-box">
				<div class="vocab-line" v-for="(v,i) in vdat.vocabulary">
					<div class="answer-holder">
						<div :class="'answer ' + (answersAreVisible ? 'transparent' : '')">{{ v.word }}</div>
						<div class="holder" :data-indx="i" v-on:drop="droppedOnHolder" v-on:dragover="draggingOnHolder"></div>
					</div>
					<div class="line">{{ v.definition }}</div>
				</div>
			</div>
			<div class="drag-from-here-line">Drag from here</div>
			<div class="word-holder row">
				<div class="movable-word col" v-for="wrd in allWords" draggable="true" v-on:mousedown="dragStart" v-on:mouseup="dragEnd">{{ wrd }}</div>
			</div>
			<a class="btnAnswer" @click="vcbANSWER">Answer</a>
			<a class="btnReset" @click="vcbRESET">Reset</a>
		</div>
	</center>
</template>

<style scoped>
	center{
		margin-top: 57px;
	}
	a.btnAnswer{
		position: absolute;
		bottom: 4em;
		right: 2em;
		background: #800000;
		color: white;
		padding: 0.25em 1em;
		border-radius: 5px;
	}
	a.btnReset{
		position: absolute;
		bottom: 1em;
		right: 2em;
		background: #03254c;
		color: white;
		padding: 0.25em 1em;
		border-radius: 5px;
	}
	a.btnAnswer:hover,a.btnReset:hover{
		color: white;
		cursor: pointer;
	}
	.transparent{
		opacity: 0;
	}
	.word-holder{
		background: rgba(255, 255, 255, 0.5);
		border-radius: 10px;
		width: 640px;
		font-size: 1.5em;
		font-weight: bold;
	}
	.movable-word{
		cursor: grab;
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		-khtml-user-select: none; /* Konqueror HTML */
		-moz-user-select: none; /* Old versions of Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none;
	}
	.movable-word:active:hover{
		cursor: grabbing;
	}
	.vocab-container{
		background: rgb(18,78,26);
		background: linear-gradient(6deg, rgba(18,78,26,1) 0%, rgba(9,121,56,1) 82%, rgba(0,0,0,1) 100%);
		width: 1024px;
		padding-top: 1em;
		padding-bottom: 1em;
		position: relative;
	}
	h1{
		font-weight: bold;
		color: white;
	}
	.drag-from-here-line{
		font-weight: bold;
		color: white;
		margin-top: 0.5em;
		margin-bottom: 0.1em;
	}
	.vocab-box{
		background: #ebf0e9;
		width: 968px;
		-webkit-box-shadow: 10px 10px 8px -1px rgba(0,0,0,0.75);
		-moz-box-shadow: 10px 10px 8px -1px rgba(0,0,0,0.75);
		box-shadow: 10px 10px 8px -1px rgba(0,0,0,0.75);
		text-align: left;
		display: flex;
		flex-direction: column;
		padding-bottom: 1.5em;
	}
	.vocab-line{
		width: 100%;
		height: 4em;
		font-weight: bold;
	}
	.answer-holder{
		float: left;
		width: 300px;
		text-align: center;
		justify-content: center;
		display: flex;
		flex-direction: column;
	}
	.answer-holder .holder{
		background: #d9af82;
		width: 200px;
		height: 2em;
		align-self: center;
		font-size: 1em;
		color: white;
		vertical-align: center;
		line-height: 2em;
	}
	.answer-holder .answer{
		color: #c4161c;
	}
	.vocab-line .line{
		display: flex;
		align-items: center;
		vertical-align: middle;
		height: 4em;
		font-size: 1.2em;
	}
	.vocab-line .line:before{
		content: "•";
		margin-left: -0.3em;
		margin-right: 0.25em;
		font-size: 1.7em;
	}
</style>

<script>
	import { ajaxGet,ajaxPost } from "../../../ajax";
  import {apiUrl} from "@/main";

	export default{
		data: function(){
			return{
				vdat: undefined,
				vocabId: undefined,
				title: undefined,
				allWords: undefined,
				leftWords: 1,
				answers: undefined,
				draggingText: undefined,
				answersAreVisible: true
			}
		},
		mounted: function(){
			this.vocabId = this.$router.history.current.params.vocabId;
			var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
			ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.vocabId,
			(dat) => {
				//on success dat is called
				if(dat.component == "vocabulary"){
					//This is the right component
					// console.log(JSON.stringify(dat.data));
					this.allWords = [];
					this.answers = [];
					this.vdat = dat.data;
					this.isAnswered = dat.answers;
					this.vdat.vocabulary.forEach(el => {
						this.allWords.push(el.word);
						this.answers.push("");
					});
					this.allWords = this.shuffle(this.allWords);
					this.title = dat.title;
					window.document.title = dat.title;
					console.log("Content Data:",JSON.parse(JSON.stringify(this.vdat)));
				}else{
					//Wrong component type
					console.error("DATA MISMATCH on api call expected 'VOCAB' object, got '" + dat.component.toUpperCase() + "' object.");
				}
				},(err) => {
					//There was some error
					console.log(err);
				}, localStorage.token);
			},
		methods: {
			shuffle: function(arr) {
				var a = [...arr];
				for (let i = a.length - 1; i > 0; i--) {
					const j = Math.floor(Math.random() * (i + 1));
					[a[i], a[j]] = [a[j], a[i]];
				}
				return a;
			},
			droppedOnHolder: function(e){
				e.preventDefault();
				if(this.draggingText){
					this.answers[e.target.dataset.indx] = this.draggingText;
					e.target.innerHTML = this.draggingText;
					this.draggingText = undefined;
				}
			},
			draggingOnHolder: function(e){
				e.preventDefault();
			},
			dragStart: function(e){
				this.draggingText = e.target.innerHTML
			},
			dragEnd: function(e){
				this.draggingText = undefined;
			},
			vcbRESET: function(e){
				location.reload();
			},
			vcbANSWER: function(e){
				console.log(this.answers);
            	//----------------------------------------------------------
				if(!this.isAnswered){
					ajaxPost(apiUrl() +"/assignments/" + this.vocabId, {
					Data: this.answers
				},
				(suc) => {
					console.log("Posted assignment:", suc);
				},
				(err) => {
					console.log("Error :", err)
				}, localStorage.token);
				}
				//----------------------------------------------------------
				this.answersAreVisible = false;
			},
			pushAnswer(){
				if(this.$router.history.current.query.Assignment === null){
					// console.log(JSON.parse(JSON.stringify(this.vdat)));
					var answers = [];
					this.score = 0;
					for(var i = 0; i < this.vdat.vocabulary.length; i++){
						var el = this.$refs["dropEl" + i][0];
						answers[i] = null;
						if(el.childNodes.length > 0){
							if(el.childNodes[0].innerHTML == this.vdat.vocabulary[i].word)
							{
								this.score += 1;
							}
							answers[i] = el.childNodes[0].innerHTML;
						}
					}
					console.log(answers);
                	//----------------------------------------------------------
					if(!this.isAnswered){
						ajaxPost(apiUrl() +"/assignments/" + this.vocabId, {
						Data: answers
					},
					(suc) => {
						console.log("Posted assignment:", suc);
					},
					(err) => {
						console.log("Error :", err)
					}, localStorage.token);
					}
					//----------------------------------------------------------
				}
			}
		}
	}
</script>